import { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { api } from '@/app/api';
import { crmBase } from '@crm/crmPaths';
import { UiButton, UiInput, UiLinkButton } from '@shared/common/ui';

export function CrmResetPasswordPage() {
  const navigate = useNavigate();
  const { ownerId } = useParams();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token')?.trim() ?? '', [searchParams]);
  const [doneMessage, setDoneMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const loginPath = crmBase(ownerId);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { password: '', passwordRepeat: '' } });

  if (!token) {
    return (
      <div className="auth-card">
        <h1>Сброс пароля CRM</h1>
        <p className="form-error">В ссылке нет ключа. Запросите восстановление пароля ещё раз.</p>
        <UiLinkButton to={loginPath} variant="link">
          На страницу входа
        </UiLinkButton>
      </div>
    );
  }

  const onSubmit = async ({ password }) => {
    setErrorMessage(null);
    try {
      const { data } = await api.post('/auth/crm/reset-password', {
        ownerId,
        token,
        password,
      });
      setDoneMessage(data.message);
      setTimeout(() => navigate(loginPath, { replace: true }), 2000);
    } catch (err) {
      setErrorMessage(err.response?.data?.message ?? 'Не удалось обновить пароль');
    }
  };

  return (
    <div className="auth-card">
      <h1>Новый пароль CRM</h1>
      {doneMessage ? (
        <div className="banner banner--info">{doneMessage}</div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <UiInput
            label="Пароль"
            type="password"
            autoComplete="new-password"
            error={errors.password?.message}
            {...register('password', {
              required: 'Введите пароль',
              minLength: { value: 6, message: 'Не меньше 6 символов' },
              maxLength: { value: 72, message: 'Не больше 72 символов' },
            })}
          />
          <UiInput
            label="Повтор пароля"
            type="password"
            autoComplete="new-password"
            error={errors.passwordRepeat?.message}
            {...register('passwordRepeat', {
              required: 'Повторите пароль',
              validate: (value, form) =>
                value === form.password ? true : 'Пароли не совпадают',
            })}
          />
          {errorMessage && <span className="form-error">{errorMessage}</span>}
          <UiButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Сохраняем…' : 'Сохранить пароль'}
          </UiButton>
        </form>
      )}
      <div style={{ marginTop: 16 }}>
        <UiLinkButton to={loginPath} variant="link">
          На страницу входа
        </UiLinkButton>
      </div>
    </div>
  );
}
